import { ace_api } from '@axo/shared/data-access/api';
import { useAPI } from '@axo/shared/data-access/provider';
import { useMutation } from 'react-query';
import { useLockAndOpenApplications } from './useLockAndOpenApplication';
import { useContext } from 'react';
import { ApplicationContext } from '../../store/context';
import { OverlayToaster } from '@blueprintjs/core';

const toaster = OverlayToaster.create({
  position: 'bottom',
});

type UseAssignNewMLApplicationsParams = {
  count?: number;
  shouldOpenAssignedApplications?: boolean;
};

export const useAssignNewMLApplications = ({
  count = 1,
  shouldOpenAssignedApplications = false,
}: UseAssignNewMLApplicationsParams) => {
  const {
    state: { marketCountry },
  } = useContext(ApplicationContext);

  const api = useAPI();
  const openApplications = useLockAndOpenApplications(marketCountry ?? '');

  return useMutation(
    () => ace_api.postAgentAssignmentsV3(api)({ Count: count }),
    {
      onSuccess: (data) => {
        if (!shouldOpenAssignedApplications) return;

        if (!data?.Applications) {
          toaster.show({
            message: data?.Message || 'No applications left to assign',
            intent: 'primary',
          });
          return;
        }

        if (data.Applications.length > 0) {
          const applicationIDs = data.Applications.map(
            (app) => app.LoanApplicationID,
          );
          openApplications(applicationIDs);
          toaster.show({
            message: `${applicationIDs.length} applications assigned and opened`,
            intent: 'success',
          });
        }
      },
    },
  );
};
